import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";
import { getHoursAndMin } from "utils/CommonFunctions";
import { getDate, getMonth } from "utils/DateHelper";
import PlanBadge from "../dashboard/PlanBadge";
import "./BrandDeadline.scss";
import { useNavigate } from "react-router-dom";

const BrandDeadline = (element: any) => {
  const navigate = useNavigate();
  return (
    <div className="brandDeadline-component" onClick={() => navigate(`/plandetails/${element?.id}`)}>
      <div className="brandDeadline-container">
        <div className="brandDeadline-wrapper">
          <div className="brandDeadline-left-section">
            <Typography variant="h4" showBold color={tokens.Text.General.Secondary} className="date-section">
              {getDate(element?.brandDeadlines?.[0]?.deadline)}
            </Typography>
            <Typography variant="body2" className="month-section" color={tokens.Text.General.Secondary}>
              {getMonth(element?.brandDeadlines?.[0]?.deadline)}
            </Typography>
          </div>
          <div className="brandDeadline-right-section">
            <div className="right-top-section">
              <div className="right-top-left-section"></div>
              <div className="right-top-right-section">
                <Timing duration={getHoursAndMin(element?.timeEstimateMinutes)} />
              </div>
            </div>
            <div className="right-medium-section">
              <Typography variant="body2" color={tokens.Text.General.Secondary} className="ellipse-two deadline-name">
                {element.name}
              </Typography>
            </div>
            <div className="right-lower-section">
              <PlanBadge data={element} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandDeadline;
